import * as React from 'react';
import * as StringHelper from '@ms/utilities-strings/lib/index';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Dialog, DialogFooter, DialogType, IDialogStyles } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { CancelError } from '../../../utilities/async/CancelError';
import MalwareDetectedStrings from './MalwareDetectedMessage.resx';
import ActionStrings from '../../scope/actions/strings.resx';
import { IMalwareDetectedWizardProps } from '../../../controls/malwareDetectedControl';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';
import { WithAction, IActionStateProps } from '../../withAction/WithAction';
import { ItemDownloadAction } from '../../actions/download/DownloadAction';

export interface IMalwareDetectedDialogState {
  startedDownload?: boolean;
}

export class MalwareDetectedDialog extends React.PureComponent<IMalwareDetectedWizardProps, IMalwareDetectedDialogState> {
  constructor(props: IMalwareDetectedWizardProps) {
    super(props);

    this.state = {};
  }

  public render(): JSX.Element | null {
    const {
      itemKey
    } = this.props;

    const onDismiss = () => {
      this.props.reject(new CancelError());
    };

    const theme = getTheme();

    return (
      <WithAction
        action={ <ItemDownloadAction itemKeys={ [itemKey] } /> }
      >
        { ({ isAvailable, execute }: IActionStateProps) => {
          const onClickDownload = isAvailable ? async () => {
            try {
              this.setState({
                startedDownload: true
              });

              await execute();

              this.props.resolve();
            } catch (e) {
              this.props.reject(e);
            }
          } : undefined;

          const malwareDetectedFormat = isAvailable ?
            MalwareDetectedStrings.malwareDetectedAllowDownloadMessage : MalwareDetectedStrings.malwareDetectedMessage;

          return !this.state.startedDownload ? (
            <Dialog
              isOpen={ true }
              onDismiss={ onDismiss }
              title={ MalwareDetectedStrings.malwareDetectedDialogHeader }
              closeButtonAriaLabel={ MalwareDetectedStrings.closeButtonAriaLabel }
              type={ DialogType.close }
              styles={ getDialogOverrideStyle }
              dialogContentProps={ {
                styles: () => {
                  return {
                    title: {
                      color: theme.semanticColors.errorText,
                      fontWeight: '500'
                    }
                  };
                }
              } }
            >
              <Label>
                { StringHelper.formatToArray(malwareDetectedFormat,
                  (
                    <a href={ 'https://go.microsoft.com/fwlink/?linkid=862871' } target='_blank'>
                      { MalwareDetectedStrings.malwareDetectedLearnMore }
                    </a>
                  ))
                }
              </Label>
              <DialogFooter>
                { onClickDownload ?
                  (
                    <DefaultButton
                      onClick={ onClickDownload }
                    >
                      { MalwareDetectedStrings.malwareDialogDownload }
                    </DefaultButton>
                  ) : null
                }
                <DefaultButton
                  onClick={ onDismiss }
                  primary={ true }
                >
                  { ActionStrings.cancelActionText }
                </DefaultButton>
              </DialogFooter>
            </Dialog>
          ) : null;
        } }
      </WithAction>
    );
  }
}

function getDialogOverrideStyle(): Partial<IDialogStyles> {
  return {
    main: {
      maxWidth: '450px !important'
    }
  };
}
